module.exports = __webpack_public_path__ + "media/images/icons/twotone/account-book-13abe3f5f8040cbe066491564bb9ceed.svg";